// import axios from "axios"
// // const baseURL='https://qdp1vbhp-8000.inc1.devtunnels.ms'

// const baseURL='https://gk-esports-backend-coral.vercel.app'   //https://backend.gkmsinfotech.com
// const api=axios.create({baseURL:`${baseURL}/auth/v1/gk`,headers:{
//     'Authorization':'Bearer '+localStorage.getItem('token')
// }})
// export default api

// // https://gk-esports-backend-coral.vercel.app

// export const url = 'https://gk-esports-backend-coral.vercel.app'

import axios from "axios";
// const baseURL='https://qdp1vbhp-8000.inc1.devtunnels.ms'

const baseURL = "https://api.gkmsinfotech.com"; //https://backend.gkmsinfotech.com
const api = axios.create({
  baseURL: `${baseURL}/auth/v1/gk`,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
  },
});
export default api;

// https://api.gkmsinfotech.com

export const url = "https://api.gkmsinfotech.com";
